document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initComparador();
  initGaleriaProducto();
  initVariantes();
  initCantidad();
  initOfertaCantidad();
  initVideoResenas();
  initHeroCarousel();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initComparador() {
  document.querySelectorAll('[data-mt-comparador]').forEach(function (wrap) {
    var asa = wrap.querySelector('.mt-comparador__asa');
    var despuesWrap = wrap.querySelector('.mt-comparador__despues-wrap');
    if (!asa || !despuesWrap) return;

    var arrastrando = false;

    function mover(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      despuesWrap.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      asa.style.left = pct + '%';
    }

    asa.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      asa.setPointerCapture(e.pointerId);
    });
    asa.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      mover(e.clientX);
    });
    asa.addEventListener('pointerup', function () { arrastrando = false; });
    wrap.addEventListener('click', function (e) {
      if (e.target === asa) return;
      mover(e.clientX);
    });
  });
}

function initGaleriaProducto() {
  var principal = document.querySelector('[data-mt-galeria-principal]');
  if (!principal) return;
  var miniaturas = document.querySelectorAll('[data-mt-miniatura]');
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var tipo = mini.getAttribute('data-tipo');
      var alt = mini.getAttribute('data-alt') || '';
      if (tipo === 'video') {
        var videoSrc = mini.getAttribute('data-video-src');
        var poster = mini.getAttribute('data-poster') || '';
        principal.innerHTML =
          '<video controls playsinline preload="metadata"' + (poster ? ' poster="' + poster + '"' : '') + '>' +
          '<source src="' + videoSrc + '" type="video/mp4"></video>';
      } else {
        var src = mini.getAttribute('data-full');
        principal.innerHTML = '<img src="' + src + '" alt="' + alt.replace(/"/g, '&quot;') + '" loading="eager">';
      }
      miniaturas.forEach(function (m) { m.classList.remove('mt-activa'); });
      mini.classList.add('mt-activa');
    });
  });
}

function initHeroCarousel() {
  document.querySelectorAll('[data-mt-hero-carousel]').forEach(function (carrusel) {
    var slides = Array.prototype.slice.call(carrusel.querySelectorAll('[data-mt-slide]'));
    var puntos = Array.prototype.slice.call(carrusel.querySelectorAll('[data-mt-punto]'));
    if (slides.length < 2) return;
    var actual = 0;
    var intervalo = parseInt(carrusel.getAttribute('data-intervalo'), 10) || 5500;
    var timer = null;

    function irA(indice) {
      slides[actual].classList.remove('mt-activa');
      if (puntos[actual]) puntos[actual].classList.remove('mt-activa');
      actual = (indice + slides.length) % slides.length;
      slides[actual].classList.add('mt-activa');
      if (puntos[actual]) puntos[actual].classList.add('mt-activa');
    }

    function siguiente() { irA(actual + 1); }

    function iniciarAuto() {
      detenerAuto();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(siguiente, intervalo);
    }
    function detenerAuto() { if (timer) { clearInterval(timer); timer = null; } }

    puntos.forEach(function (punto) {
      punto.addEventListener('click', function () {
        irA(parseInt(punto.getAttribute('data-index'), 10));
        iniciarAuto();
      });
    });

    carrusel.addEventListener('mouseenter', detenerAuto);
    carrusel.addEventListener('mouseleave', iniciarAuto);

    iniciarAuto();
  });
}

function initVideoResenas() {
  document.querySelectorAll('[data-mt-video-tarjeta]').forEach(function (tarjeta) {
    tarjeta.addEventListener('click', function () {
      if (tarjeta.querySelector('video')) return;
      var src = tarjeta.getAttribute('data-video-src');
      if (!src) return;
      tarjeta.innerHTML = '<video src="' + src + '" controls autoplay playsinline></video>';
    });
  });
}

function initVariantes() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;

  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var inputId = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio-actual]');
  var precioTachadoEl = document.querySelector('[data-mt-precio-tachado]');
  var botonComprar = document.querySelector('[data-mt-btn-comprar]');
  var disponibilidadEl = document.querySelector('[data-mt-disponibilidad]');
  var selectorOpciones = document.querySelectorAll('[data-mt-opcion]');
  if (!selectorOpciones.length) return;

  function opcionesSeleccionadas() {
    var seleccion = [];
    document.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
      var activo = grupo.querySelector('.mt-activa');
      seleccion.push(activo ? activo.getAttribute('data-valor') : null);
    });
    return seleccion;
  }

  function encontrarVariante() {
    var seleccion = opcionesSeleccionadas();
    return variantes.find(function (v) {
      return v.options.every(function (op, i) { return op === seleccion[i]; });
    });
  }

  function formatoMoneda(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
    });
  }

  function actualizar() {
    var variante = encontrarVariante();
    if (!variante) return;
    if (inputId) inputId.value = variante.id;
    if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
    if (precioTachadoEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioTachadoEl.textContent = formatoMoneda(variante.compare_at_price);
        precioTachadoEl.style.display = '';
      } else {
        precioTachadoEl.style.display = 'none';
      }
    }
    if (botonComprar) botonComprar.disabled = !variante.available;
    if (disponibilidadEl) {
      if (variante.available) {
        disponibilidadEl.textContent = disponibilidadEl.getAttribute('data-texto-ok') || 'En stock';
        disponibilidadEl.className = 'mt-compra__disponibilidad mt-compra__disponibilidad--ok';
      } else {
        disponibilidadEl.textContent = disponibilidadEl.getAttribute('data-texto-agotado') || 'Agotado';
        disponibilidadEl.className = 'mt-compra__disponibilidad mt-compra__disponibilidad--agotado';
      }
    }
    if (variante.featured_image) {
      var principal = document.querySelector('[data-mt-galeria-principal]');
      if (principal) {
        principal.innerHTML = '<img src="' + variante.featured_image + '" alt="' +
          (variante.featured_image_alt || '').replace(/"/g, '&quot;') + '" loading="eager">';
      }
      var miniaturaCoincide = document.querySelector('[data-mt-miniatura][data-full="' + variante.featured_image + '"]');
      if (miniaturaCoincide) {
        document.querySelectorAll('[data-mt-miniatura]').forEach(function (m) { m.classList.remove('mt-activa'); });
        miniaturaCoincide.classList.add('mt-activa');
      }
    }
  }

  var nombreTonoEl = document.querySelector('[data-mt-tono-nombre]');

  selectorOpciones.forEach(function (grupo) {
    grupo.querySelectorAll('[data-valor]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        grupo.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('mt-activa'); });
        btn.classList.add('mt-activa');
        if (nombreTonoEl && btn.hasAttribute('data-nombre')) {
          nombreTonoEl.textContent = btn.getAttribute('data-nombre');
        }
        actualizar();
      });
    });
  });

  actualizar();
}

function initOfertaCantidad() {
  var oferta = document.querySelector('[data-mt-oferta]');
  if (!oferta) return;
  var tarjetas = oferta.querySelectorAll('.mt-formato');
  var cantidadInput = document.querySelector('input[name="quantity"]');
  if (!cantidadInput) {
    // No hay selector de cantidad visible (rediseño 2026): crea uno oculto para el formulario.
    var formulario = document.querySelector('[data-mt-form-producto]');
    if (!formulario) return;
    cantidadInput = document.createElement('input');
    cantidadInput.type = 'hidden';
    cantidadInput.name = 'quantity';
    cantidadInput.value = '1';
    formulario.appendChild(cantidadInput);
  }

  tarjetas.forEach(function (tarjeta) {
    tarjeta.addEventListener('click', function () {
      tarjetas.forEach(function (t) { t.classList.remove('mt-activa'); });
      tarjeta.classList.add('mt-activa');
      var cantidad = parseInt(tarjeta.getAttribute('data-cantidad'), 10) || 1;
      cantidadInput.value = cantidad;
    });
  });
}

function initCantidad() {
  document.querySelectorAll('[data-mt-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-menos]');
    var mas = wrap.querySelector('[data-mas]');
    if (!input) return;
    if (menos) menos.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (mas) mas.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
}
